// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrivacyPolicy {
  width: 80%;
  margin: auto;
  padding-top: 100px;
  margin-bottom: 100px;
}

h3 {
  margin-bottom: 0px;
}

p {
  margin-top: 5px;
}

@media (max-width: 1024px) {
  .PrivacyPolicy {
    padding-top: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Privacy.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":[".PrivacyPolicy {\r\n  width: 80%;\r\n  margin: auto;\r\n  padding-top: 100px;\r\n  margin-bottom: 100px;\r\n}\r\n\r\nh3 {\r\n  margin-bottom: 0px;\r\n}\r\n\r\np {\r\n  margin-top: 5px;\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .PrivacyPolicy {\r\n    padding-top: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
